import React from "react";
import { BookAudio, Users, ListMusic, CheckCircle2, TrendingUp, Star } from "lucide-react";
import { useLang } from "../../context/LanguageContext";
import { useCatalog } from "../../context/CatalogContext";
import { useAuth } from "../../context/AuthContext";

export default function AdminDashboard() {
  const { t } = useLang();
  const { adminBooks: books } = useCatalog();
  const { users } = useAuth();

  const totalChapters = books.reduce((s, b) => s + b.chapters.length, 0);
  const published = books.filter((b) => b.status === "published").length;

  const stats = [
    { icon: BookAudio, label: t("total_books"), value: books.length, color: "text-brand-400 bg-brand-500/10 border-brand-500/25" },
    { icon: Users, label: t("total_users"), value: users.length, color: "text-sky-400 bg-sky-500/10 border-sky-500/25" },
    { icon: ListMusic, label: t("total_chapters"), value: totalChapters, color: "text-violet-400 bg-violet-500/10 border-violet-500/25" },
    { icon: CheckCircle2, label: t("published"), value: published, color: "text-emerald-400 bg-emerald-500/10 border-emerald-500/25" },
  ];

  const topBooks = [...books].sort((a, b) => b.ratingCount - a.ratingCount).slice(0, 5);

  return (
    <div className="animate-float-up">
      <h1 className="font-display text-3xl font-semibold tracking-tight mb-1">{t("admin_dashboard")}</h1>
      <p className="text-sm text-muted-foreground mb-8">
        {"Overview of your Trellure platform"}
      </p>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
        {stats.map((s) => (
          <div key={s.label} className="rounded-2xl border border-border bg-card/50 p-5">
            <div className={`w-11 h-11 rounded-xl border flex items-center justify-center mb-4 ${s.color}`}>
              <s.icon className="w-5 h-5" />
            </div>
            <div className="font-display text-3xl font-semibold">{s.value}</div>
            <div className="text-xs text-muted-foreground mt-1">{s.label}</div>
          </div>
        ))}
      </div>

      <div className="rounded-2xl border border-border bg-card/50 overflow-hidden">
        <div className="px-5 py-4 border-b border-border flex items-center gap-2">
          <TrendingUp className="w-4 h-4 text-brand-400" />
          <h2 className="font-semibold">{"Top audiobooks"}</h2>
        </div>
        <div className="divide-y divide-border/60">
          {topBooks.map((b, i) => (
            <div key={b.id} className="flex items-center gap-4 px-5 py-3">
              <span className="w-6 text-center font-display font-semibold text-muted-foreground">{i + 1}</span>
              <img src={b.cover} alt="" className="w-10 h-14 rounded-md object-cover" />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium truncate">{b.title_en}</p>
                <p className="text-xs text-muted-foreground truncate">{b.author}</p>
              </div>
              <span className="flex items-center gap-1 text-sm text-brand-400 font-medium">
                <Star className="w-3.5 h-3.5" fill="currentColor" /> {b.rating}
              </span>
              <span className="text-xs text-muted-foreground w-20 text-right">{b.ratingCount} {t("ratings")}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
